<button class="action" [ngClass]="{'active':active}">
    <div class="action-media">
        <ng-content select="fui-icon"></ng-content>
    </div>
</button>
